module.exports = __webpack_public_path__ + "static/media/golf_cart.2397998a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/golf_cart.svg
// module id = 533
// module chunks = 0